export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./currencies.vue?vue&type=template&id=004a891a"


//////////////////
// WEBPACK FOOTER
// ./src/components/system/currencies.vue?vue&type=template&id=004a891a
// module id = WJfn
// module chunks = 0